import{Component}from '@theme/component';import{onDocumentLoaded,changeMetaThemeColor,setHeaderMenuStyle}from '@theme/utilities';class HeaderComponent extends Component{requiredRefs=['headerDrawerContainer','headerMenu','headerRowTop'];#menuDrawerHiddenWidth=null;#intersectionObserver=null;#offscreen=!1;#lastScrollTop=0;#timeout=null;#scrollRafId=null;#resizeObserver=new ResizeObserver(([entry])=>{if(!entry||!entry.borderBoxSize[0])return;const roundedHeaderHeight=Math.round(entry.borderBoxSize[0].blockSize);document.body.style.setProperty('--header-height',`${roundedHeaderHeight}px`);if(this.#menuDrawerHiddenWidth&&window.innerWidth>this.#menuDrawerHiddenWidth){this.#updateMenuVisibility(!1)}});#observeStickyPosition=(alwaysSticky=!0)=>{if(this.#intersectionObserver)return;const config={threshold:alwaysSticky?1:0,};this.#intersectionObserver=new IntersectionObserver(([entry])=>{if(!entry)return;const{isIntersecting}=entry;if(alwaysSticky){this.dataset.stickyState=isIntersecting?'inactive':'active';if(this.dataset.themeColor)changeMetaThemeColor(this.dataset.themeColor);}else{this.#offscreen=!isIntersecting||this.dataset.stickyState==='active'}},config);this.#intersectionObserver.observe(this)};#handleOverflowMinimum=(event)=>{this.#updateMenuVisibility(event.detail.minimumReached)};#updateMenuVisibility(hideMenu){if(hideMenu){this.#menuDrawerHiddenWidth=window.innerWidth}else{this.#menuDrawerHiddenWidth=null}
setHeaderMenuStyle()}
#handleWindowScroll=()=>{if(this.#scrollRafId!==null)return;this.#scrollRafId=requestAnimationFrame(()=>{this.#scrollRafId=null;this.#updateScrollState()})};#updateScrollState=()=>{const stickyMode=this.getAttribute('sticky');if(!this.#offscreen&&stickyMode!=='always')return;const scrollTop=document.scrollingElement?.scrollTop??0;const headerTop=this.getBoundingClientRect().top;const isScrollingUp=scrollTop<this.#lastScrollTop;const isAtTop=headerTop>=0;if(this.#timeout){clearTimeout(this.#timeout);this.#timeout=null}
if(stickyMode==='always'){if(isAtTop){this.dataset.scrollDirection='none'}else if(isScrollingUp){this.dataset.scrollDirection='up'}else{this.dataset.scrollDirection='down'}
this.#lastScrollTop=scrollTop;return}
if(isScrollingUp){if(isAtTop){this.#offscreen=!1;this.dataset.stickyState='inactive';this.dataset.scrollDirection='none'}else{this.dataset.stickyState='active';this.dataset.scrollDirection='up'}}else if(this.dataset.stickyState==='active'){this.dataset.scrollDirection='none';this.dataset.stickyState='idle'}else{this.dataset.scrollDirection='none';this.dataset.stickyState='idle'}
this.#lastScrollTop=scrollTop};connectedCallback(){super.connectedCallback();this.#resizeObserver.observe(this);this.addEventListener('overflowMinimum',this.#handleOverflowMinimum);const stickyMode=this.getAttribute('sticky');if(stickyMode){this.#observeStickyPosition(stickyMode==='always');if(stickyMode==='scroll-up'||stickyMode==='always'){document.addEventListener('scroll',this.#handleWindowScroll)}}}
disconnectedCallback(){super.disconnectedCallback();this.#resizeObserver.disconnect();this.#intersectionObserver?.disconnect();this.removeEventListener('overflowMinimum',this.#handleOverflowMinimum);document.removeEventListener('scroll',this.#handleWindowScroll);if(this.#scrollRafId!==null){cancelAnimationFrame(this.#scrollRafId);this.#scrollRafId=null}
document.body.style.setProperty('--header-height','0px')}}
if(!customElements.get('header-component')){customElements.define('header-component',HeaderComponent)}
onDocumentLoaded(()=>{const header=document.querySelector('header-component');const headerGroup=document.querySelector('#header-group');if(headerGroup){const resizeObserver=new ResizeObserver((entries)=>{const headerGroupHeight=entries.reduce((totalHeight,entry)=>{if(entry.target!==header||(header.hasAttribute('transparent')&&header.parentElement?.nextElementSibling)){return totalHeight+(entry.borderBoxSize[0]?.blockSize??0)}
return totalHeight},0);const roundedHeaderGroupHeight=Math.round(headerGroupHeight);document.body.style.setProperty('--header-group-height',`${roundedHeaderGroupHeight}px`)});if(header instanceof HTMLElement){resizeObserver.observe(header)}
const children=headerGroup.children;for(let i=0;i<children.length;i++){const element=children[i];if(element instanceof HTMLElement){resizeObserver.observe(element)}}
const mutationObserver=new MutationObserver((mutations)=>{for(const mutation of mutations){if(mutation.type==='childList'){const children=headerGroup.children;for(let i=0;i<children.length;i++){const element=children[i];if(element instanceof HTMLElement){resizeObserver.observe(element)}}}}});mutationObserver.observe(headerGroup,{childList:!0})}})

onDocumentLoaded(()=>{const header=document.querySelector('header-component');if(!(header instanceof HTMLElement))return;const syncLogoVisibility=()=>{const logo=header.querySelector('.header-logo');if(!logo)return;const original=logo.querySelector('.header-logo__image-container--original');const inverse=logo.querySelector('.header-logo__image-container--inverse');if(!(original instanceof HTMLElement)||!(inverse instanceof HTMLElement))return;const transparent=header.hasAttribute('transparent');if(transparent){original.style.setProperty('display','none','important');inverse.style.setProperty('display','block','important')}else{original.style.setProperty('display','block','important');inverse.style.setProperty('display','none','important')}};syncLogoVisibility();const observer=new MutationObserver(syncLogoVisibility);observer.observe(header,{attributes:!0,attributeFilter:['transparent']})})

;(() => {
  const flag = '__ycMainHeaderResizeSync';
  if (window[flag]) return;
  window[flag] = true;

  const styleId = 'yc-main-header-resize-sync-style';

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      body:has(main[data-template='index']) #header-component[transparent][data-sticky-state='active'] {
        background: var(--color-scheme-top-row, #55654b) !important;
        --color-scheme-bottom-row: var(--color-scheme-top-row, #55654b) !important;
      }

      body:has(main[data-template='index']) #header-component[transparent][data-sticky-state='active'] .header__underlay-closed {
        background: var(--color-scheme-top-row, #55654b) !important;
      }
    `;
    document.head.appendChild(style);
  }

  function init() {
    ensureStyle();

    const header = document.querySelector('#header-component');
    const headerGroup = document.querySelector('#header-group');
    if (!(header instanceof HTMLElement) || !(headerGroup instanceof HTMLElement)) return;

    let frame = 0;

    function sync() {
      const headerTopRow = header.querySelector('.header__row--top');
      const headerHeight = Math.round(header.getBoundingClientRect().height);
      const overflowList = header.querySelector('overflow-list');
      const isTouchDevice = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
      const hasReachedMinimum = overflowList && overflowList.hasAttribute('minimum-reached');

      header.dataset.menuStyle = isTouchDevice || hasReachedMinimum ? 'drawer' : 'menu';

      if (headerHeight > 0) {
        document.body.style.setProperty('--header-height', `${headerHeight}px`);
      }

      if (headerTopRow instanceof HTMLElement) {
        const topRowHeight = Math.round(headerTopRow.getBoundingClientRect().height);
        if (topRowHeight > 0) {
          header.style.setProperty('--top-row-height', `${topRowHeight}px`);
          document.body.style.setProperty('--top-row-height', `${topRowHeight}px`);
        }
      }

      let headerGroupHeight = 0;
      const children = headerGroup.children;
      for (let i = 0; i < children.length; i++) {
        const element = children[i];
        if (!(element instanceof HTMLElement)) continue;
        headerGroupHeight += Math.round(element.getBoundingClientRect().height);
      }

      if (header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
        headerGroupHeight += headerHeight;
      }

      document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
    }

    function scheduleSync() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        sync();
        window.requestAnimationFrame(sync);
      });
    }

    scheduleSync();
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('orientationchange', scheduleSync, { passive: true });
    window.addEventListener('pageshow', scheduleSync);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleSync, { passive: true });
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(scheduleSync);
      resizeObserver.observe(header);
      resizeObserver.observe(headerGroup);
    }

    const mutationObserver = new MutationObserver(scheduleSync);
    mutationObserver.observe(header, {
      attributes: true,
      subtree: true,
      attributeFilter: ['minimum-reached', 'data-sticky-state', 'transparent']
    });
  }

  onDocumentLoaded(init);
})();
